export const LAUNCH_DARKLY_CLIENT_SIDE_IDS = {
    local: '61a9f77ca7a8d31143a37089',
    development: '61a9f77ca7a8d31143a37089',
    staging: '61a9f4a34e7888116e020694',
    onboarding: '61a9f4afc6a5f10dd1217229',
    production: '61a9f4530be7e9119fa0857e',
};
//# sourceMappingURL=launchDarkly.js.map